import ApiService from '@/services/common/api.service';
import Utils from '@/helpers/utils';
import DateUtils from '@/helpers/dateUtils';
import { Constants } from "@/helpers/constants";
import _ from 'lodash';

const DOCManagementService = {
    listDOC,
    addDOC,
    detailDOC,
    editDOC,
    deleteDOC,
};

/*
    List DOC
*/
async function listDOC (page) {
    let url = '/doc';

    let query = {};

    if (page) {
        query.page = page;
        query.pageSize = Constants.ItemPerpage;
    }

    if (Utils.isEmptyObj(query) == false) {
        let httpBuildQuery = require('http-build-query');
        url += "?" + httpBuildQuery(query);
    }

    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Add DOC
*/
async function addDOC (params) {
    let url = '/doc';

    let body = {};

    Utils.trimObject(params);

    body.connection = _.trim(params.connection);
    body.loginId = _.trim(params.loginId);
    body.loginPw = _.trim(params.loginPw);

    if (!Utils.isEmptyStr(params.start)) {
        body.start = DateUtils.formatDateDefault(params.start);
    } else {
        body.start = "";
    }

    if (!Utils.isEmptyStr(params.end)) {
        body.end = DateUtils.formatDateDefault(params.end);
    } else {
        body.end = "";
    }

    try {
        let response = await ApiService.post(url, body);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Detail DOC
*/
async function detailDOC (id) {
    let url = '/doc/' + id;
    try {
        let response = await ApiService.get(url);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Edit DOC
*/
async function editDOC (ids, params) {
    let url = "/doc";

    let body = {};

    Utils.trimObject(params);

    if (ids.length == 1) {
        url = url + "/" + ids[0];
    } else {
        body.ids = ids;
    }

    body.connection = _.trim(params.connection);
    body.loginId = _.trim(params.loginId);
    body.loginPw = _.trim(params.loginPw);

    if (!Utils.isEmptyStr(params.start)) {
        body.start = DateUtils.formatDateDefault(params.start);
    } else {
        body.start = "";
    }

    if (!Utils.isEmptyStr(params.end)) {
        body.end = DateUtils.formatDateDefault(params.end);
    } else {
        body.end = "";
    }

    try {
        let response = await ApiService.put(url, body);
        return response;
    } catch (error) {
        return error;
    }
}

/*
    Delete DOC
*/
async function deleteDOC (ids) {
    let url = '/doc';
    let body = {};

    if (ids.length == 1) {
        url = url + "/" + ids[0];
    } else {
        body.ids = ids;
    }

    let requestData = {
        method: 'DELETE',
        url: url,
        data: body,
    };

    try {
        let response = await ApiService.customRequest(requestData);
        return response;
    } catch (error) {
        return error;
    }
}

export default DOCManagementService;



// WEBPACK FOOTER //
// ./src/services/admin/doc.service.js